var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-menu',{attrs:{"mode":"vertical","collapse":_vm.isCollapse,"unique-opened":"","default-active":_vm.$route.path,"background-color":"#324157","text-color":"#bfcbd9","active-text-color":"#20a0ff"}},[_c('sidebar-item',{attrs:{"routes":_vm.itemRoute}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }